module.exports = __webpack_public_path__ + "static/media/CrowdStrike_light_mode.5791df49.png";